import { useContext } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';

// Aprova a edição das lâminas (inspetor) — pedido segue para impressão.
// Para aprovar: TODAS as lâminas aprovadas + uma lâmina de capa selecionada.
const FinishSpreadInspectionButton = ({ order }) => {
  const { hasPermissions } = useContext(AuthContext);

  const spreadPhotos = (order.photos || []).filter(
    (photo) => photo.photo_type === 'Lâmina'
  );

  const allApproved =
    spreadPhotos.length > 0 &&
    spreadPhotos.every((photo) => photo.photo_status === 'Aprovada');

  const hasCover = spreadPhotos.some((photo) => photo.is_cover_photo);

  const canApprove = allApproved && hasCover;

  let reason = '';
  if (!allApproved) reason = 'Todas as lâminas devem estar aprovadas.';
  else if (!hasCover) reason = 'Selecione uma lâmina de capa.';

  return (
    <>
      {order.order_status === 'Inspeção de edição de lâminas' &&
        hasPermissions([
          'edit_inspection',
          'edit_order',
          'seller_inspection',
        ]) && (
          <div className="col-sm col-md-6 col-xl-4 mt-2">
            <button
              className="btn btn-success btn-block col-12"
              type="button"
              disabled={!canApprove}
              data-bs-toggle={canApprove ? 'modal' : undefined}
              data-bs-target={
                canApprove ? '#modal-approve-spread-edit-order' : undefined
              }
            >
              aprovar edição de lâminas
            </button>

            {!canApprove && (
              <small className="text-danger d-block mt-1">{reason}</small>
            )}
          </div>
        )}
    </>
  );
};

FinishSpreadInspectionButton.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
    photos: PropTypes.arrayOf(Object),
  }).isRequired,
};

export default FinishSpreadInspectionButton;
